"use strict";

const StructuralBmpFactSheetController = function () {
  const routeName = "sbmp-fact-sheet";

  const sbmpFactSheetRoute = {
    as: routeName,
    handler: function ({ data, hashString }) {
      open(data.id, { highlightId: hashString });
    },
  };

  const sbmpFactSheetHighlightRoute = {
    as: `${routeName}-highlight`,
    handler: sbmpFactSheetRoute.handler,
  };

  var getConfig = function () {
    const StructuralBmpsGeoServerLayer = require("../bmpFcsG2/structuralBmpsGeoServerLayer");
    const SortUtilities = require("../general/sortUtilities");
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;

    return {
      template: "factSheet/bmpfcs/sbmpFactSheet.njk",
      polygonColumnName: "projectAreaGeom",
      pointColumnName: "geom",
      iconFunction: StructuralBmpsGeoServerLayer.getTableIcon,
      closeUrl: "/ram/bmpram/bmp",
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: getData,
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      readOnlyPhotos: true,
      apiAssetName: "bmp",
      dataSorting: {
        history: { key: "date", reversed: true },
      },
      tableTemplates: {
        history: "factSheet/bmpfcs/sbmpHistoryRows.njk",
      },
      sortersDict: {
        displayType: alphaSorter,
        assetId: alphaSorter,
        type: alphaSorter,
        date: alphaSorter,
        lastResultDate: alphaSorter,
        installDate: alphaSorter,
        result: alphaSorter,
        displayResult: alphaSorter,
        lastResult: alphaSorter,
        treatmentCapacity: numberSorter,
        drainageArea: numberSorter,
        imperviousAreaAcres: numberSorter,
        openFindingsCount: numberSorter,
        details: alphaSorter,
      },
    };
  };

  var getData = async function (id) {
    try {
      return await ApiCalls.getBmpFactSheet(id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
    }

    return await ResourceController.get("structuralBmps").getById(id);
  };

  var prepareData = function (data) {
    const ToolSettings = require("../settings/toolSettings");
    const assetName = ToolSettings.getSetting("constants", "assetDisplayNames", "bmp");
    data.assetDisplayType = data.bmpTypeName ? `${assetName} - ${data.bmpTypeName}` : assetName;

    data.dataView = Tree.get("dataView");
    data.phaseColor = data.phase ? BmpFcsIcon.getIconColorByPhase(data.phase, true) : "#ffffff";
    data.phaseTextColor = Misc.isDarkColor(data.phaseColor) ? "#fff" : "#000";

    data.showDeleteSbmpButton = data.permissions?.canBeDeleted;
    data.showRoutineMaintenanceButton = false;
    data.showAddNewBenchmarkButton = true;
    data.skipBenchmark = BmpFunctions.getSkipBenchmark(data);
    if (!data.skipObservation) {
      StructuralBmpDataListController.addSbmpAssessmentActionDropdown(data, data.skipBenchmark);
    }
    if (!data.skipBenchmark) {
      StructuralBmpDataListController.addSbmpBenchmarkActionDropdown(data);
    }

    data.readOnlyTopLevel = Session.isRegulator();
    if (data.history?.history) {
      data.history = data.history.history;
    }
    FactSheetNew.addDisplayDates(data.history);

    data.showMaintenanceZone = Tree.get("availableDataSortLayers").includes("maintenanceZones");

    Tree.set("currentBmpFcs", data);
    PopupContent.handleAssessmentHistoryReadOnly(data.history);

    data.assetAge = AssetsPopupFunctions.getAssetAge(data.installationDate);
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
    _handleSectionDisplay();
    // @TODO: Set up sbmp events
  };

  var _unloadListeners = function () {
    $("#fact-sheet-container")
      .off("click", ".add-assessment-button", showNewBmpAssessmentClick)
      .off("click", ".add-benchmark-button", showNewBenchmarkClick)
      .off("click", ".edit-benchmark-button", showEditBenchmarkClick)
      .off("click", ".edit-description", _clickEditDescription)
      .off("click", "#edit-general-info", _clickEditGeneralInfo)
      .off("click", "#add-file, .edit-file", _clickAddFile)
      .off("click", ".download-file", _downloadFile)
      .off("click", ".js-edit-assessment", _editAssessmentClick)
      .off("click", ".js-view-assessment", _viewAssessmentClick)
      .off("click", ".js-delete-assessment", _deleteAssessmentClick)
      .off("click", ".download-report", _downloadReportClick);
  };

  var _loadListeners = function () {
    _unloadListeners();
    $("#fact-sheet-container")
      .on("click", ".add-assessment-button", showNewBmpAssessmentClick)
      .on("click", ".add-benchmark-button", showNewBenchmarkClick)
      .on("click", ".edit-benchmark-button", showEditBenchmarkClick)
      .on("click", ".edit-description", _clickEditDescription)
      .on("click", "#edit-general-info", _clickEditGeneralInfo)
      .on("click", "#add-file, .edit-file", _clickAddFile)
      .on("click", ".download-file", _downloadFile)
      .on("click", ".js-edit-assessment", _editAssessmentClick)
      .on("click", ".js-view-assessment", _viewAssessmentClick)
      .on("click", ".js-delete-assessment", _deleteAssessmentClick)
      .on("click", ".download-report", _downloadReportClick);
  };

  var _openModalToPage = function (page) {
    BmpFcsInventoryModalController.invokeBmpInventoryModal(FactSheetNew.getId(), page);
  };

  var onClose = function () {
    _unloadListeners();
  };

  var _clickEditDescription = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _clickEditGeneralInfo = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _clickAddFile = function () {
    _openModalToPage("bmp-fcs-information");
  };

  var _downloadFile = function (e) {
    const data = $(e.currentTarget).parents(`[data-category=permit]`).data();
    if (data.idBmp && data.filename) {
      ApiCalls.downloadTrashAttachment(data.idBmp, data.filename, "fcs", "additional");
    }
  };

  var _handleSectionDisplay = function () {
    const $factSheetContainer = $("#fact-sheet-container");
    $factSheetContainer
      .find("#sbmp-general-info-section")
      .find(".fact-group")
      .each(function () {
        if ($(this).find(".fact-item.hide").length === $(this).find(".fact-item").length) {
          $(this).addClass("hide");
        }
      });
  };

  var showNewBenchmarkClick = function () {
    const data = $(this).closest("#action-dropdown").data();
    Benchmark.showNewBenchmarkModal(data.bmpName, data.type, data.typeNumber);
  };

  var showEditBenchmarkClick = function () {
    const data = $(this).closest("#action-dropdown").data();
    Benchmark.showEditBenchmarkModal(
      data.bmpName,
      data.idBmp,
      data.type,
      data.typeNumber,
      data.bm_id,
      false,
    );
  };

  var showNewBmpAssessmentClick = function () {
    const data = $(this).closest("#action-dropdown").data();

    BmpObservation.showBmpObsModal(data.idBmp, data.bmpName, data.type, data.typeNumber, false);
  };

  var _editAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    const readOnly = false;
    BmpFunctions.editHistory(data, readOnly);
  };

  var _viewAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    const readOnly = true;
    BmpFunctions.editHistory(data, readOnly);
  };

  var _deleteAssessmentClick = function () {
    const $row = FactSheetNew.$getRow($(this));
    const data = $row.data();
    BmpFunctions.confirmDeleteHistory($row, data);
  };

  var _downloadReportClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();

    if (data.assetType === "bmp") {
      Analytics.sendPopupEvent("download_report", "bmp");
      ApiCalls.downloadBmpObservationPdf(data.obs_id);
    } else if (["routineMaintenance", "routineRepair"].includes(data.assetType)) {
      Analytics.sendPopupEvent("download_report", "muni-bmp");
      ApiCalls.downloadMuniBmpPdf(data.id);
    } else if (data.assetType === "lid-receive-notice") {
      Analytics.sendPopupEvent("download_report", "lid-receive-notice");
      ApiCalls.downloadLidResponsePdf(data.id);
    } else {
      throw new Error(`No download defined for ${data.assetType}`);
    }
  };

  return {
    routeName,
    sbmpFactSheetRoute,
    sbmpFactSheetHighlightRoute,
    open,
    getConfig,
    prepareData,
  };
};

module.exports = StructuralBmpFactSheetController();

const ApiCalls = require("../apiCalls");
const ApiError = require("../errors/apiError");
const ResourceController = require("../offline/resourceController");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Session = require("../login/session");
const Tree = require("../tree");
const Misc = require("../misc");
const StructuralBmpDataListController = require("./structuralBmpDataListController");
const BmpFunctions = require("../modals/bmpFunctions");
const Benchmark = require("../modals/benchmark");
const BmpObservation = require("../modals/bmpObservation");
const BmpFcsIcon = require("./bmpFcsIcon");
const BmpFcsInventoryModalController = require("./bmpFcsInventoryModalController");
const PopupContent = require("../mapFunctions/popupContent");
const AssetsPopupFunctions = require("../assetManagement/assetsPopupFunctions");
